import { of } from 'rxjs';
import { number } from 'yup/lib/locale';

//set list endpoint url with parameters
let listTableUrlParamObj: any = {};

export function setUpListEndpoint(listUrl: string, newParams?: any) {
  listTableUrlParamObj = {};

  newParams &&
    newParams.map((paramArr: any) => {
      if (paramArr.value !== null) {
        listTableUrlParamObj[paramArr.param] = paramArr.value;
      } else {
        delete listTableUrlParamObj[paramArr.param];
      }
    });

  const urlParamStr =
    '?' + new URLSearchParams(listTableUrlParamObj).toString();

  return listUrl + urlParamStr;
}

//provide edited values from returned endpoint data for the table list
export function tableDataValues(infoListData: any) {
  //returned data, one variable to edit, another as the original for backup
  const listDataOriginal = JSON.parse(
    JSON.stringify(Object.assign({}, infoListData))
  );
  const listData = infoListData;

  //organised column data
  const dataColumns = listData
    ? listData.columns
        .map((col: any) => {
          col.columnKey = col.columnKey.toLowerCase();
          return col;
        })
        .sort((col1: { orderNumber: number }, col2: { orderNumber: number }) =>
          col1.orderNumber > col2.orderNumber ? 1 : -1
        )
    : undefined;

  //list of column keys, keep after previously organised column data
  const dataColumnKeys = listData
    ? dataColumns.map((item: { columnKey: string }) => item.columnKey)
    : undefined;

  //organised list item data
  const dataItems = listData
    ? listData.listData.map((item: any) => {
        const lcKeyNames = Object.keys(item).map((key) => {
          const newKey = key.indexOf('__') !== -1 ? key.toLowerCase() : key;
          return { [newKey]: item[key] };
        });
        const newItem = Object.assign({}, ...lcKeyNames);
        return newItem;
      })
    : undefined;

  //list of all id's currently seen on page
  const allCheckedIds = listData
    ? dataItems.map((item: any) => {
        return item[dataColumnKeys[0]];
      })
    : undefined;

  //find out if any of the table columns are filterable, otherwise don't show the filter icon
  let tableToFilter =
    listData && dataColumns.some((column: any) => column.bFilterable === true);

  return {
    listDataOriginal,
    listData,
    dataColumns,
    dataColumnKeys,
    dataItems,
    allCheckedIds,
    tableToFilter,
  };
}

//pagination values
export function tablePaginationValues(
  infoListData: any,
  listUrl: string,
  loadInfoTableList: (listUrl: string, paramsArr?: any) => void
) {
  //returned data, one variable to edit, another as the original for backup
  const listData = infoListData;

  //page number
  const pageNumber = listData && (infoListData.pageNumber === 0 ? 1 : infoListData.pageNumber);

  //page size
  const pageSize = listData && infoListData.pageSize;

  //total item number
  const resultsCount = listData && infoListData.resultsCount;

  //total number of pages
  const countDividedBySize = Math.ceil(resultsCount / pageSize);
  const totalPages = !countDividedBySize || !pageSize ? 1 : Math.ceil(resultsCount / pageSize);

  //dropdown values
  let ddValArr = [];
  if(listData){
    for(let k = 0; k < listData.resultsCount; k++){
      if(k > 0 && k % 10 === 0){
        ddValArr.push(k);
      }
    }

    if(listData.resultsCount < 10){
      ddValArr.push(10);
    }    

    if(listData.resultsCount > ddValArr[ddValArr.length - 1]){
      ddValArr.push(ddValArr[ddValArr.length - 1] + 10);
    }

    if(ddValArr.length <= 0){
      ddValArr.push(10);
    }
  }

  //page item start and end numbers
  let itemNumCounter = resultsCount;
  for (let i = 1; i < pageNumber; i++) {
    itemNumCounter -= pageSize;
  }
  let itemNumStart = resultsCount - itemNumCounter + 1;
  let itemNumEnd =
    resultsCount - itemNumCounter + pageSize > resultsCount
      ? resultsCount
      : resultsCount - itemNumCounter + pageSize;

  //make previous and next pagination buttons active
  let previousBtnsInactive = pageNumber === 1;

  let nextBtnsInactive =
    (resultsCount - itemNumCounter + pageSize >= resultsCount) || !pageSize;

  //go to page via dropdown
  function pageSizeViaDropdown(event: any) {
    loadInfoTableList(listUrl, [
      { param: 'pageSize', value: parseInt(event.target.value) },
      { param: 'pageNumber', value: 1 },
    ]);
  }

  //go to page via input number
  function goToPageViaInput(event: any) {
    //check key code
    let keynum;

    if (window.event) {
      // IE
      keynum = event.keyCode;
    } else if (event.which) {
      // Netscape/Firefox/Opera
      keynum = event.which;
    }

    //check value is a number, otherwise provide last entry
    if (
      !isNaN(event.target.value) &&
      parseInt(event.target.value) &&
      !(parseInt(event.target.value) > totalPages)
    ) {
      //if enter pressed (code 13) trigger load refresh
      if (keynum === 13) {
        loadInfoTableList(listUrl, [
          { param: 'pageNumber', value: parseInt(event.target.value) },
        ]);
      }
    } else {
      //event.target.value = pageNumber;
    }
  }

  //go to first page
  function goToFirstPage() {
    loadInfoTableList(listUrl, [{ param: 'pageNumber', value: 1 }]);
  }

  //go to previous page
  function goToPreviousPage() {
    loadInfoTableList(listUrl, [
      { param: 'pageNumber', value: listData.pageNumber - 1 },
    ]);
  }

  //go the next page
  function goToNextPage() {
    loadInfoTableList(listUrl, [
      { param: 'pageNumber', value: listData.pageNumber + 1 },
    ]);
  }

  //go to last page
  function goToLastPage() {
    loadInfoTableList(listUrl, [{ param: 'pageNumber', value: totalPages }]);
  }

  return {
    pageNumber,
    pageSize,
    resultsCount,
    totalPages,
    ddValArr,
    itemNumStart,
    itemNumEnd,
    previousBtnsInactive,
    nextBtnsInactive,
    pageSizeViaDropdown,
    goToPageViaInput,
    goToFirstPage,
    goToPreviousPage,
    goToNextPage,
    goToLastPage,
  };
}

//set up first column width detection
export function firstColWidthDetect(
  isDesktopOrLaptop: boolean,
  lgColWidth: number | undefined,
  smColWidth: number | undefined
) {
  //default width inherit
  let firstColWidth = 'inherit';

  //add large screen width
  if (lgColWidth) {
    if (!isDesktopOrLaptop) {
      firstColWidth = lgColWidth + 'px';
    }
  }

  //add small screen width
  if (smColWidth) {
    if (isDesktopOrLaptop) {
      firstColWidth = smColWidth + 'px';
    }
  }

  return firstColWidth;
}

//check item values types and convert accordingly, e.g. money, dates
export function checkItemValType(item: any, column: string) {
  switch (true) {
    case column.toLowerCase().indexOf('date') !== -1:
      const newDate =
        item[column].indexOf('T') !== -1
          ? item[column].split('T')[0].split('-').reverse().join('/')
          : item[column].split('-').reverse().join('/');

      return newDate;
    case column.toLowerCase().indexOf('amount') !== -1:
      return '£' + item[column].toFixed(2);
    default:
      return item[column];
  }
}

//toggle all list checkboxes
export function toggleSelectAll(
  event: React.ChangeEvent<HTMLInputElement>,
  setCheckedIds: React.Dispatch<React.SetStateAction<any[]>>,
  allChkChecked: Array<number>,
  getSelectedIdsFunc?: any,
  getSelectedOpts?: any,
) {
  if (event.target.checked) {
    if(getSelectedOpts){
      getSelectedIdsFunc(allChkChecked);
    }

    setCheckedIds(allChkChecked);
  } else {
    if(getSelectedOpts){
      getSelectedIdsFunc([]);
    }  

    setCheckedIds([]);  
  }
}

//toggle checkboxes
export function toggleCurrentChkBox(
  checkboxList: Array<number>,
  setCheckboxList: React.Dispatch<React.SetStateAction<number[]>>,
  setSelectedRowName: React.Dispatch<React.SetStateAction<string>>,
  currentId: number,
  rowName: string,
  allowSelectAll: boolean,
  getSelectedIdsFunc?: any,
  getSelectedOpts?: any,
) {
  const isChecked =
    checkboxList.filter((id) => {
      return id === currentId;
    }).length > 0;

  if (isChecked) {
    setCheckboxList((ids) => {
        if(getSelectedOpts){
          getSelectedIdsFunc(ids.filter((i) => {
            return i.toString() !== currentId.toString();
          }));
        }

        return ids.filter((i) => {
          return i.toString() !== currentId.toString();
        });
      }
    );
    setSelectedRowName('');
  } else {
    if (allowSelectAll) {
      setCheckboxList((ids) => {
        if(getSelectedOpts){
          getSelectedIdsFunc([...ids, currentId]);
        }

        return [...ids, currentId];
      });
      setSelectedRowName('');
    } else {
      setCheckboxList([currentId]);
      setSelectedRowName(rowName);
    }
  }
}

//check/uncheck checkboxes
export function assignCheck(checkboxList: Array<number>, currentId: number) {
  return (
    checkboxList.filter((id) => {
      return id === currentId;
    }).length > 0
  );
}

//sort table data by column
export function sortCol(
  columnKey: string,
  listUrl: string,
  loadInfoTableList: (listUrl: string, paramsArr?: any) => void,
  infoListData?: any
) {
  if (infoListData.sortBy) {
    const currentSortCol: string = infoListData.sortBy.substr(
      0,
      infoListData.sortBy.indexOf(' ')
    );
    const currentSortBy: string = infoListData.sortBy.substring(
      infoListData.sortBy.lastIndexOf(' ')
    );
    let newSortBy = null;

    if (currentSortCol.indexOf(columnKey) !== -1) {
      const sortCheck = currentSortBy === ' DESC' ? ' ASC' : '';
      newSortBy = sortCheck === '' ? null : columnKey + sortCheck;
    } else {
      newSortBy = columnKey + ' DESC';
    }

    loadInfoTableList(listUrl, [{ param: 'sortBy', value: newSortBy }]);
  } else {
    loadInfoTableList(listUrl, [
      { param: 'sortBy', value: columnKey + ' DESC' },
    ]);
  }
}
